var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ApiModel } from "./api-model";
import { Language } from "./language";
import { UserProfile } from "./user-profile";
import { Privilege } from "./privilege";
var User = /** @class */ (function (_super) {
    __extends(User, _super);
    function User(data) {
        var _this = _super.call(this, data) || this;
        _this.resetPassword = false;
        if (data.languages) {
            _this.languages = data.languages.map(function (language) { return new Language(language); });
            _this.currentLanguage = _this.languages.find(function (language) { return language.isDefault === true; });
        }
        if (data.privileges) {
            _this.privileges = data.privileges.map(function (privilege) { return new Privilege(privilege); });
        }
        else {
            _this.privileges = [];
        }
        if (data.userPrivileges) {
            _this.userPrivileges = data.userPrivileges.map(function (privilege) { return new Privilege(privilege); });
        }
        else {
            _this.userPrivileges = [];
        }
        if (data.profiles) {
            _this.profiles = data.profiles.map(function (profile) { return new UserProfile(profile); });
        }
        else {
            _this.profiles = [];
        }
        if (_this.lastName) {
            _this.cleanedLastName = _this.lastName;
            if (_this.lastName.includes(".external")) {
                _this.cleanedLastName = _this.lastName.replace(".external", "");
            }
        }
        return _this;
    }
    Object.defineProperty(User.prototype, "isExternal", {
        get: function () {
            return !this.isFromActiveDirectory;
        },
        set: function (value) {
            this.isFromActiveDirectory = !value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "specificRights", {
        get: function () {
            return this.userPrivileges.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "defaultLanguage", {
        get: function () {
            return this.languages.find(function (language) { return language.isDefault === true; });
        },
        set: function (language) {
            this.languages.map(function (lang) { return (lang.isDefault = false); });
            this.languages.find(function (lang) { return lang.id === language.id; }).isDefault = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "rights", {
        get: function () {
            var rights = [];
            this.profiles.forEach(function (profile) { return rights.concat(profile.privileges); });
            return rights.concat(this.privileges);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "fullName", {
        get: function () {
            var fullName = "";
            if (this.firstName) {
                fullName = this.firstName + " ";
            }
            if (this.lastName) {
                fullName += this.lastName;
            }
            return fullName;
        },
        enumerable: true,
        configurable: true
    });
    return User;
}(ApiModel));
export { User };



// WEBPACK FOOTER //
// ./src/app/models/user.ts.pre-build-optimizer.js